import { React, Component } from 'utils';

export default class Page extends Component {

	constructor(props)
	{
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {
		event.preventDefault();

		var { onClick, model } = this.props;

		if(onClick) {
			onClick(model);
		}
	}

	render() {
		var { model } = this.props;

		return <li className={ model.active?'active':'' }>
			<a href="#" onClick={this.handleClick}>{ model.page + 1 }</a>
		</li>
	}
}



// WEBPACK FOOTER //
// ./src/modules/app/resumes/Page.js